import React from 'react'
import { useTranslation } from 'react-i18next'

const LANGS = [
  { code: 'fr', label: 'FR' },
  { code: 'de', label: 'DE' },
  { code: 'en', label: 'EN' }
]

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  return (
    <div className="flex items-center gap-1">
      {LANGS.map(l => (
        <button
          key={l.code}
          className={`px-2 py-1 rounded ${i18n.language?.startsWith(l.code) ? 'bg-primary text-white' : 'bg-white border border-blue-100'}`}
          onClick={() => i18n.changeLanguage(l.code)}
          aria-label={`Switch language to ${l.label}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  )
}
